import { JSX } from 'react';
import {
    List,
    TextField,
    Datagrid,
    EditButton,
    ReferenceOneField
} from 'react-admin';


export const MysteryShopperList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ false }
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="name"  />
                <ReferenceOneField reference="admin_users" source="adminUser" target="id" >
                    <TextField source="name" />
                </ReferenceOneField>
                <EditButton />
            </Datagrid>
        </List>
    );
}
